import React from 'react';
import BasicInformation from '../Publish/ProductDetails/BasicInformation';
import MarketInformation from '../Publish/ProductDetails/MarketInformation';
import AdditionalInformation from '../Publish/ProductDetails/AdditionalInformation';

const ProductDetailsView = ({ publishData }) => {
  console.log('ProductDetailsView - publishData:', publishData);
  console.log('ProductDetailsView - ProductInfo:', publishData?.ProductInfo);
  
  if (!publishData?.ProductInfo) {
    console.log('ProductDetailsView - No ProductInfo found');
    return <div>No product information available.</div>;
  }
  
  const productInfo = publishData.ProductInfo;
  console.log('ProductDetailsView - productInfo:', productInfo);
  
  // Filter out cost-related fields to ensure no cost information is displayed
  const filteredProductInfo = { ...productInfo };
  
  // Remove cost-related fields
  delete filteredProductInfo.costThreshold;
  delete filteredProductInfo.azureServicesCost;
  delete filteredProductInfo.developmentCosts;
  delete filteredProductInfo.supportCosts;
  delete filteredProductInfo.operationCosts;
  
  console.log('ProductDetailsView - filteredProductInfo (no costs):', filteredProductInfo);
  
  return (
    <div className="space-y-6">
      <BasicInformation productInfo={filteredProductInfo} />
      <MarketInformation productInfo={filteredProductInfo} />
      <AdditionalInformation productInfo={filteredProductInfo} />
    </div>
  );
};

export default ProductDetailsView; 